<template>
	<div class="history">
		<b-container class="mt-top text-left prl-outside">
			<b-row class="mb-3 top-text">{{$t('history')}}</b-row>

			<b-row class="prl-inside">
				<b-col cols="12" class="p-0 two-in-a-row">
					<p class="m-0 fw800">1992</p>
					<p>{{$t('text1992_1')}}</p>
					<p>{{$t('text1992_2')}}</p>

					<p class="m-0 mt-4 fw800">1993</p>
					<p>{{$t('text1993')}}</p>

					<p class="m-0 mt-4 fw800">1997</p>
					<p>{{$t('text1997')}}</p>

					<p class="m-0 mt-4 fw800">2000</p>
					<p>{{$t('text2000_1')}}</p>
					<p>{{$t('text2000_2')}}</p>

					<p class="m-0 mt-4 fw800">2003</p>
					<p>{{$t('text2003')}}</p>

					<p class="m-0 mt-4 fw800">2010</p>
					<p>{{$t('text2010_1')}}</p>
					<p>{{$t('text2010_2')}}</p>

					<p class="m-0 mt-4 fw800">2013</p>
					<p>{{$t('text2013')}}</p>

					<p class="m-0 mt-4 fw800">2019</p>
					<p>{{$t('text2019_1')}}</p>
					<p>{{$t('text2019_2')}}</p>

					<p class="m-0 mt-4 fw800">2022</p>
					<p>{{$t('text2022')}}</p>

					<p class="m-0 mt-4 fw800 fs-italic">{{$t('text_1')}} <span class="fw300 fs-normal">{{$t('text_2')}}</span></p>
				</b-col>
			</b-row>
		</b-container>
		<div class="big-text">{{$t('history')}}</div>
	</div>
</template>

<script>
export default {
	name: 'History',
	data () {
		return {
		}
	}
}
</script>
<style scoped>
	p {
		width: 100%;
		font-size: 0.9rem;
	}
	.two-in-a-row {
		column-count:2; column-gap: 40px;text-align: justify;
	}
	@media only screen and (max-width: 576px) {
		.two-in-a-row {
			column-count:1;
		}
	}
	.mt40 {
		margin-top:40px !important;
	}
	.fs-normal {
		font-style: normal;
	}
	.fs-italic {
		font-style: italic;
	}
</style>
<i18n>
	{
		"de": {
			"history": "Geschichte",
			"text1992_1": "Mit der Gründung von Gera im Jahr 1992 durch Helmut Raggam begann auch die andauernde Erfolgsgeschichte. Der Montagefachbetrieb in Seiersberg bei Graz wurde nach und nach zu einer festen Größe im Bereich der Montage von hochwertigen Tischlereiprodukten ausgebaut.",
			"text1992_2": "Einige der ersten Mitarbeiter sind dem Unternehmen bis heute treu geblieben und konnten durch ihre große Kompetenz und Einsatzbereitschaft das Unternehmen prägen und einen großen Teil zum erfolgreichen Aufbau beitragen.",
			"text1993": "Bereits ein Jahr nach der Gründung wurde das erste Projekt außerhalb Österreichs umgesetzt: Die Montage der Zimmer des Hotel Maritim in Stuttgart.",
			"text1997": "Wegen der steigenden Mitarbeiterzahlen und Aufträge wuchs das Unternehmen aus dem Betriebsstandort Seiersberg heraus und wurde nach Mettersdorf am Saßbach in die Südsteiermark verlegt. Dort findet das Unternehmen bis heute sein Zuhause.",
			"text2000_1": "Zur Jahrtausendwende wurde das Unternehmen mit der Verleihung der goldenen Erzherzog-Johann-Medaille durch die Steirische Wirtschaftskammer ausgezeichnet.",
			"text2000_2": "Im selben Jahr wurde das Geschäftsfeld um die Sparte Interieur-Montagen auf Luxusyachten erweitert. Das Projekt „Superfast Ferry“ in Dänemark war das erste Schiffsprojekt.",
			"text2003": "Durch souveränes und kompetentes Auftreten sicherte sich GERA einen Namen in der Montage-Branche. Zu dieser Zeit sind bereits über 90 motivierte Montagetischler beschäftigt, die Projekte in und außerhalb Europas wie z. B. in New York, Miami und Rabat abwickeln.",
			"text2010_1": "Große Eröffnungsfeier des neu errichteten Bürogebäudes in Mettersdorf am Saßbach.",
			"text2010_2": "Beim „Austrians Leading Companies“-Award für nachhaltiges Wachstum und solide finanzielle Basis wurde GERA mit dem sensationellen zweiten Platz in der Kategorie „Solide Kleinbetriebe Österreichs“ ausgezeichnet.",
			"text2013": "Ein besonderes Jahr, in dem wir den bislang größten Hotel-Montageauftrag zur vollsten Zufriedenheit unseres Auftraggebers abwickeln durften. Das Luxushotel „The Hotel“ in einer Toplage in Brüssel überzeugt mit extravagantem Design und neu-modernem Luxus – und wir durften dabei mithelfen, dem Hotel diesen besonderen Charme zu verleihen.",
			"text2019_1": "Bereits im Jahr 2004 durften wir im größten Hotel Österreichs, dem „Hilton Hotel – Vienna“, arbeiten. Viele Jahre später wurden wir wieder beauftragt, in über 660 Zimmern die Montage von Türen sowie der Zimmer- und Suitenmöbel durchzuführen.",
			"text2019_2": "Luxus, den man sich kaum vorstellen kann: In den vergangenen 15 Jahren war GERA-Montagen auf 6 der 10 größten Luxusyachten der Welt tätig. Auf Luxusschiffen, die so groß wie mehrere Einfamilienhäuser sind und ein Vermögen kosten, hatten wir die exklusive Möglichkeit, Decken zu verkleiden sowie Einrichtungsgegenstände und Wandverkleidungen zu montieren.",
			"text2022": "„Jede Vision beginnt mit einem Gedanken. Jeder Erfolg mit der praktischen Umsetzung.“ Im Jahr 2022 darf GERA mit Stolz auf 30 erfolgreiche Jahre als Montagefachbetrieb für Tischlereiprodukte zurückblicken. Zum Jubiläum wurde als Dank an alle Mitarbeiter ein internes, über 30 Wochen laufendes Gewinnspiel, bestehend aus 30 Fragen und 30 tollen Preisen, ins Leben gerufen - mit einem „Grande Finale“ inkl. Live-Challenge um die drei großen Hauptpreise am Jahresende.",
			"text_1": "„Mit unseren qualifizierten Mitarbeitern legen wir unseren Fokus auf Termintreue, höchste Qualität und Kundenzufriedenheit. Zahlreiche namhafte Kunden aus dem In- und Ausland im Bereich Hochbau sowie im Schiffs- und Yachtsektor zählen zu unserem Stammklientel.“",
			"text_2": "– so Helmut Raggam, Gründer von GERA."
		},
		"en": {
			"history": "History",
			"text1992_1": "Our continuing success story began in 1992 when Helmut Raggam founded Gera. Our specialist installation business in Seiersberg bei Graz has gradually developed into an important player for installing high-quality carpentry products.",
			"text1992_2": "Some of the initial employees have remained loyal to the company and have been able to make a substantial contribution to successfully shaping and expanding it by their high level of expertise and dedication.",
			"text1993": "After just one year in business the first project outside of Austria was completed: installing the rooms of Maritim Hotel in Stuttgart.",
			"text1997": "Because of the increasing numbers of employees and orders, the company grew out of the Seiersberg location and was moved to Mettersdorf am Sassbach in southern Styria. The company still has its home there today.",
			"text2000_1": "At the turn of the millennium our company was awarded the gold Archduke Johann Medal by the Styrian Chamber of Commerce.",
			"text2000_2": "That same year our business was expanded by the interior luxury yacht installation division. The “Superfast Ferry” project in Denmark was the first ship project.",
			"text2003": "GERA secured a good name for itself in the installation industry by its confident appearance and expert work. At this time more than 90 motivated installation carpenters were already employed who completed projects in Europe and elsewhere such as in New York, Miami and Rabbat.",
			"text2010_1": "Grand opening ceremony for the newly constructed office building in Mettersdorf am Sassbach.",
			"text2010_2": "At the Austria’s Leading Companies award ceremony for sustainable growth and a solid financial basis, GERA was awarded with a sensational second place in the “Solid small businesses in Austria” (Solide Kleinbetriebe Österreichs) category.",
			"text2013": "An extraordinary year when we were able to complete our largest hotel installation job up to that point to the complete satisfaction of our customer. “The Hotel”, a luxury hotel in a top location in Brussels, is impressive with its extravagant design and new, modern luxury, and we were able to help give this hotel its special charm.",
			"text2019_1": "In 2004 we were able to work at the Vienna Hilton Hotel, the largest hotel in Austria. Years later we were commissioned again to install doors as well as suite and room furniture in over 660 rooms.",
			"text2019_2": "Luxury that you can hardly imagine: for the past 15 years GERA-Montagen has worked on 6 of the 10 largest luxury yachts in the world. These are luxury boats that are as large as several single-family homes and cost a fortune. We had the exclusive opportunity to mount many fixtures, cover ceilings, mount wallcoverings and much more on these yachts.",
			"text_1": "„With the help of our qualified employees we put our focus on adherence to deadlines, top quality and customer satisfaction. Our core clientele includes many high-profile customers both inside and outside of Austria in the area of building construction and in the ship and yacht sector“",
			"text_2": ", says Helmut Raggam, the founder of GERA."
		}
	}
</i18n>
